import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TrlPillContainer, TrlPillLabel } from '../TrlPill.styles';
import { TrlPillCleanStyled } from './TrlPillClean.styles';

export const TrlPillClean = () => {
  return (
    <TrlPillContainer>
      <TrlPillCleanStyled />
      <TrlPillLabel>
        <FormattedMessage id="TRLT_UI-EXCHANGE" />
      </TrlPillLabel>
    </TrlPillContainer>
  );
};
